import React, { useState } from 'react';
import DayCareProviderScheduler from './DayCareProviderScheduler';
import ServiceProviderScheduler from './ServiceProviderScheduler';
import HomeHealthCareScheduler from './HomeHealthCareScheduler';
import { Box } from '@mui/material';

const Scheduler = (props) => {
  const isServiceProvider = props.user.comp_settings.find(setting => setting.feature_id === 102 && setting.feature_value === 'primaryBusinessType');
  const isHomeHealthCare = props.user.comp_settings.find(setting => setting.feature_id === 103 && setting.feature_value === 'primaryBusinessType');

  return (
    <Box>
      {isServiceProvider ? <ServiceProviderScheduler {...props} /> : isHomeHealthCare ? <HomeHealthCareScheduler {...props} /> : <DayCareProviderScheduler {...props} />}
    </Box>
  )
}

export default Scheduler;